"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _menuStoreTemplate = require("@/api/goods/menuStoreTemplate");
var _dishGroup = require("@/api/goods/dishGroup");
var _goods_activity_combo = require("@/api/goods_activity/goods_activity_combo");
var _scheduledShelfTask = require("@/api/goods/scheduledShelfTask");
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'groupListing',
  data: function data() {
    return {
      // Group list
      tableData: [],
      // Selected groups for shelf operation
      availableGroups: [],
      // All available groups for add dialog
      filteredGroupList: [],
      // Groups filtered by search
      groupSearch: '',
      groupSearchLoading: false,
      groupSearchTimer: null,
      selectedTableProducts: [],
      // Operation configuration
      form: {
        operation: '',
        scene: [],
        stores: []
      },
      submitting: false,
      storeSearch: '',
      selectedStoreCount: 0,
      treeData: [],
      menuTypeList: [],
      // Scene types from queryMenuType

      // Validation rules
      rules: {
        operation: [{
          required: true,
          message: '请选择操作类型',
          trigger: 'change'
        }]
      },
      // Scheduled tasks
      scheduleDialogVisible: false,
      scheduleSubmitting: false,
      scheduleForm: {
        scheduledTime: '',
        operation: '',
        scene: [],
        stores: [],
        groupIds: [],
        taskName: ''
      },
      scheduleRules: {
        scheduledTime: [{
          required: true,
          message: '请选择执行时间',
          trigger: 'change'
        }],
        taskName: [{
          required: true,
          message: '请输入任务名称',
          trigger: 'blur'
        }]
      },
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      // Task management
      taskManageDialogVisible: false,
      taskList: [],
      taskLoading: false,
      taskPagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      // Related groups dialog
      relatedGroupsDialogVisible: false,
      relatedGroupsList: [],
      relatedGroupsLoading: false,
      // Group shelf import
      importDialogVisible: false,
      addDialogVisible: false,
      selectedGroups: [],
      groupShelfImporting: false,
      groupShelfTaskVisible: false,
      groupShelfTaskId: null,
      groupShelfTaskStatus: '',
      groupShelfTaskTimer: null,
      // Upload headers
      uploadHeaders: {
        "X-Token": (0, _auth.getToken)()
      },
      groupShelfUploadUrl: process.env.VUE_APP_PIM_API + 'xyMenuStoreTemplate/importGroupShelfExcel',
      // Store import
      storeImportDialogVisible: false,
      storeImporting: false,
      storeImportForm: {
        operation: 'check'
      }
    };
  },
  computed: {
    headerCellStyle: function headerCellStyle() {
      return {
        background: '#F5F5F7',
        color: '#1D1D1F',
        fontWeight: 600,
        fontSize: '13px',
        borderBottom: '1px solid #E5E5E7'
      };
    },
    uploadUrl: function uploadUrl() {
      return process.env.VUE_APP_PIM_API + 'xyMenuStoreTemplate/importExcel';
    }
  },
  watch: {
    storeSearch: function storeSearch(val) {
      var _this = this;
      if (this.$refs.treeRef) {
        this.$refs.treeRef.filter(val ? val.trim() : '');
        if (!val || !val.trim()) {
          this.$nextTick(function () {
            _this.collapseAllTreeNodes();
          });
        }
      }
    }
  },
  mounted: function mounted() {
    this.getStoreList();
    this.getMenuType();
    this.loadAvailableGroups();
  },
  beforeDestroy: function beforeDestroy() {
    // Clean up search timer
    if (this.groupSearchTimer) {
      clearTimeout(this.groupSearchTimer);
    }
  },
  methods: {
    // Load available dish groups
    loadAvailableGroups: function () {
      var _loadAvailableGroups = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return (0, _dishGroup.queryList)({
                page: 1,
                limit: 1000
              });
            case 1:
              res = _context.sent;
              this.availableGroups = res.records || [];
              this.filteredGroupList = (0, _toConsumableArray2.default)(this.availableGroups);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadAvailableGroups() {
        return _loadAvailableGroups.apply(this, arguments);
      }
      return loadAvailableGroups;
    }(),
    // Get menu types
    getMenuType: function getMenuType() {
      var _this2 = this;
      (0, _goods_activity_combo.queryMenuType)().then(function (res) {
        if (res.code === 200 || res.code === 0) {
          _this2.menuTypeList = res.data.records || [];
        }
      });
    },
    // Get store list
    getStoreList: function getStoreList() {
      var _this3 = this;
      (0, _goods_activity_combo.queryRegionStoreList)().then(function (res) {
        if (res.code === 200 || res.code === 0) {
          var regions = res.data.storeRegions || [];
          _this3.treeData = regions.map(function (region) {
            return {
              id: "region_".concat(region.regionId),
              label: region.regionName,
              isRegion: true,
              storeCount: region.storeList ? region.storeList.length : 0,
              children: (region.storeList || []).map(function (store) {
                return {
                  id: store.storeId,
                  label: store.storeName,
                  isRegion: false
                };
              })
            };
          });
          _this3.$nextTick(function () {
            _this3.initDefaultSelection();
          });
        }
      });
    },
    // Initialize default selection
    initDefaultSelection: function initDefaultSelection() {
      if (this.$refs.treeRef) {
        this.handleCheck();
      }
    },
    // 过滤树节点
    filterStoreNode: function filterStoreNode(value, data, node) {
      if (!value) return true;
      var query = value.trim().toLowerCase();
      if (!query) return true;

      // 1. 节点自身名称匹配
      if (data && data.label && data.label.toLowerCase().includes(query)) {
        return true;
      }

      // 2. 如果是门店节点（叶子节点），所属大区名称匹配也视为匹配
      if (node && node.parent && node.parent.data && node.parent.data.label) {
        if (node.parent.data.label.toLowerCase().includes(query)) {
          return true;
        }
      }

      // 3. 如果是大区节点，其子门店中有任意一个匹配，则该大区保留展示
      if (node && node.childNodes && node.childNodes.length > 0) {
        return node.childNodes.some(function (child) {
          return child.data && child.data.label && child.data.label.toLowerCase().includes(query);
        });
      }
      return false;
    },
    // 收起所有树节点
    collapseAllTreeNodes: function collapseAllTreeNodes() {
      if (!this.$refs.treeRef) return;
      var root = this.$refs.treeRef.root;
      if (root && root.childNodes) {
        root.childNodes.forEach(function (node) {
          node.expanded = false;
        });
      }
    },
    // Handle check event
    handleCheck: function handleCheck() {
      var _this4 = this;
      this.$nextTick(function () {
        var checkedNodes = _this4.$refs.treeRef.getCheckedNodes(true);
        _this4.selectedStoreCount = checkedNodes.length;
        _this4.form.stores = checkedNodes.map(function (node) {
          return node.id;
        });
      });
    },
    // Select all stores
    handleCheckAll: function handleCheckAll() {
      this.$refs.treeRef.setCheckedNodes(this.getAllLeafNodes(this.treeData));
      this.handleCheck();
    },
    // Uncheck all stores
    handleUncheckAll: function handleUncheckAll() {
      this.$refs.treeRef.setCheckedKeys([]);
      this.handleCheck();
    },
    // Get all leaf nodes
    getAllLeafNodes: function getAllLeafNodes(nodes) {
      var _this5 = this;
      var leafNodes = [];
      nodes.forEach(function (node) {
        if (node.children && node.children.length > 0) {
          leafNodes = leafNodes.concat(_this5.getAllLeafNodes(node.children));
        } else {
          leafNodes.push(node);
        }
      });
      return leafNodes;
    },
    // Handle table selection change
    handleTableSelectionChange: function handleTableSelectionChange(selection) {
      this.selectedTableProducts = selection;
    },
    // Batch remove groups
    handleBatchRemove: function handleBatchRemove() {
      var _this6 = this;
      if (this.selectedTableProducts.length === 0) {
        this.$message.warning('请至少选择一个分组');
        return;
      }
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u9009\u4E2D\u7684 ".concat(this.selectedTableProducts.length, " \u4E2A\u5206\u7EC4\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var selectedIds = _this6.selectedTableProducts.map(function (item) {
          return item.id;
        });
        _this6.tableData = _this6.tableData.filter(function (item) {
          return !selectedIds.includes(item.id);
        });
        _this6.selectedTableProducts = [];
        _this6.$message.success('批量删除成功');
      }).catch(function () {});
    },
    // Handle group selection in add dialog
    handleGroupSelection: function handleGroupSelection(selection) {
      this.selectedGroups = selection;
    },
    // Search groups - with API call and debounce
    handleGroupSearch: function handleGroupSearch() {
      var _this7 = this;
      // Clear previous timer
      if (this.groupSearchTimer) {
        clearTimeout(this.groupSearchTimer);
      }

      // If search is empty, load all groups
      if (!this.groupSearch || this.groupSearch.trim() === '') {
        this.filteredGroupList = (0, _toConsumableArray2.default)(this.availableGroups);
        this.$nextTick(function () {
          return _this7.setExistingGroupSelection();
        });
        return;
      }

      // Set loading state
      this.groupSearchLoading = true;

      // Debounce API call (300ms)
      this.groupSearchTimer = setTimeout(function () {
        _this7.performGroupSearch();
      }, 300);
    },
    // Perform the actual search API call
    performGroupSearch: function () {
      var _performGroupSearch = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this8 = this;
        var res, _t;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _dishGroup.queryList)({
                page: 1,
                limit: 100,
                keywords: this.groupSearch.trim()
              });
            case 1:
              res = _context2.sent;
              if (res.code === 200 || res.code === 0) {
                this.filteredGroupList = res.records || [];
                this.$nextTick(function () {
                  return _this8.setExistingGroupSelection();
                });
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t = _context2["catch"](0);
              console.error('搜索分组失败:', _t);
              // 不显示错误提示，避免打扰用户
            case 3:
              _context2.prev = 3;
              this.groupSearchLoading = false;
              return _context2.finish(3);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2, 3, 4]]);
      }));
      function performGroupSearch() {
        return _performGroupSearch.apply(this, arguments);
      }
      return performGroupSearch;
    }(),
    // Set existing selection in add dialog
    setExistingGroupSelection: function setExistingGroupSelection() {
      var _this9 = this;
      if (!this.$refs.groupTableRef) return;
      this.$refs.groupTableRef.clearSelection();
      var existingIds = new Set(this.tableData.map(function (item) {
        return item.id;
      }));
      this.filteredGroupList.forEach(function (row) {
        if (existingIds.has(row.id)) {
          _this9.$refs.groupTableRef.toggleRowSelection(row, true);
        }
      });
    },
    // Submit immediate operation
    handleSubmit: function handleSubmit() {
      var _this0 = this;
      if (!this.form.operation) {
        this.$message.warning('请选择操作类型');
        return;
      }
      if (!this.form.scene.length) {
        this.$message.warning('请选择场景');
        return;
      }
      if (!this.selectedStoreCount) {
        this.$message.warning('请选择门店');
        return;
      }
      if (!this.tableData.length) {
        this.$message.warning('请选择分组');
        return;
      }
      this.submitting = true;
      var params = {
        operation: this.form.operation,
        scene: this.form.scene,
        stores: this.form.stores,
        groupIds: this.tableData.map(function (item) {
          return item.id;
        })
      };
      (0, _menuStoreTemplate.updGroupShelfStatus)(params).then(function (res) {
        if (res.code === 0 || res.code === 200) {
          _this0.$message.success('操作成功');
        }
      }).catch(function (err) {
        _this0.$message.error(err.message || '操作失败');
      }).finally(function () {
        _this0.submitting = false;
      });
    },
    // Cancel
    handleCancel: function handleCancel() {
      this.$refs.formRef.resetFields();
      this.tableData = [];
    },
    // Open add group dialog
    handleOpenAddGroupDialog: function handleOpenAddGroupDialog() {
      var _this1 = this;
      this.addDialogVisible = true;
      this.groupSearch = '';
      this.groupSearchLoading = false;
      if (this.groupSearchTimer) {
        clearTimeout(this.groupSearchTimer);
        this.groupSearchTimer = null;
      }
      this.filteredGroupList = (0, _toConsumableArray2.default)(this.availableGroups);
      this.$nextTick(function () {
        _this1.setExistingGroupSelection();
      });
    },
    // Close add dialog
    handleCloseAddDialog: function handleCloseAddDialog() {
      this.addDialogVisible = false;
      this.groupSearch = '';
      this.selectedGroups = [];
    },
    // Confirm add groups
    handleConfirmAdd: function handleConfirmAdd() {
      var _this$tableData;
      if (this.selectedGroups.length === 0) {
        this.$message.warning('请至少选择一个分组');
        return;
      }
      var existingIds = new Set(this.tableData.map(function (item) {
        return item.id;
      }));
      var newGroups = this.selectedGroups.filter(function (group) {
        return !existingIds.has(group.id);
      });
      (_this$tableData = this.tableData).push.apply(_this$tableData, (0, _toConsumableArray2.default)(newGroups));
      this.addDialogVisible = false;
      var duplicateCount = this.selectedGroups.length - newGroups.length;
      if (newGroups.length > 0) {
        this.$message.success("\u6210\u529F\u6DFB\u52A0 ".concat(newGroups.length, " \u4E2A\u5206\u7EC4"));
      }
    },
    // Remove group
    handleRemove: function handleRemove(row) {
      var _this10 = this;
      this.$confirm("\u786E\u5B9A\u8981\u79FB\u9664\u5206\u7EC4 \"".concat(row.name, "\" \u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var index = _this10.tableData.findIndex(function (item) {
          return item.id === row.id;
        });
        if (index > -1) {
          _this10.tableData.splice(index, 1);
        }
        _this10.$message.success('移除成功');
      }).catch(function () {});
    },
    // Open scheduled task dialog
    handleOpenScheduleDialog: function handleOpenScheduleDialog() {
      if (!this.form.operation) {
        this.$message.warning('请选择操作类型');
        return;
      }
      if (!this.form.scene.length) {
        this.$message.warning('请选择场景');
        return;
      }
      if (!this.selectedStoreCount) {
        this.$message.warning('请选择门店');
        return;
      }
      if (!this.tableData.length) {
        this.$message.warning('请选择分组');
        return;
      }
      this.scheduleForm = {
        scheduledTime: '',
        operation: this.form.operation,
        scene: this.form.scene,
        stores: this.form.stores,
        groupIds: this.tableData.map(function (item) {
          return item.id;
        }),
        taskName: "".concat(this.form.operation === '1' ? '上架' : '下架', "\u4EFB\u52A1-").concat(new Date().getTime())
      };
      this.scheduleDialogVisible = true;
    },
    // Confirm scheduled task creation
    handleConfirmSchedule: function handleConfirmSchedule() {
      var _this11 = this;
      this.$refs.scheduleFormRef.validate(function (valid) {
        if (valid) {
          _this11.scheduleSubmitting = true;
          (0, _scheduledShelfTask.createGroupScheduledTask)(_this11.scheduleForm).then(function (res) {
            if (res.code === 0 || res.code === 200) {
              _this11.$message.success('定时任务创建成功');
              _this11.scheduleDialogVisible = false;
            }
          }).catch(function (err) {
            _this11.$message.error(err.message || '创建失败');
          }).finally(function () {
            _this11.scheduleSubmitting = false;
          });
        }
      });
    },
    // Open task management
    handleOpenTaskManage: function handleOpenTaskManage() {
      this.taskManageDialogVisible = true;
      this.handleQueryScheduledTasks();
    },
    // Query scheduled tasks
    handleQueryScheduledTasks: function handleQueryScheduledTasks() {
      var _this12 = this;
      this.taskLoading = true;
      var params = {
        page: this.taskPagination.page,
        limit: this.taskPagination.limit
      };
      (0, _scheduledShelfTask.queryGroupShelfTaskPage)(params).then(function (res) {
        if (res.code === 0 || res.code === 200) {
          _this12.taskList = res.data.records || [];
          _this12.taskPagination.total = res.data.total || 0;
        }
      }).catch(function (err) {
        _this12.$message.error(err.message || '查询失败');
      }).finally(function () {
        _this12.taskLoading = false;
      });
    },
    // Get scene names
    getSceneNames: function getSceneNames(sceneCodes) {
      var _this13 = this;
      if (!sceneCodes || sceneCodes.length === 0) return '-';
      var names = sceneCodes.map(function (code) {
        var item = _this13.menuTypeList.find(function (m) {
          return m.code === code;
        });
        return item ? item.desc : code;
      });
      return names.join(', ');
    },
    // Get task status text
    getTaskStatusText: function getTaskStatusText(status) {
      var statusMap = {
        0: '待执行',
        1: '已成功',
        2: '执行中',
        '-1': '失败'
      };
      return statusMap[status] || '未知';
    },
    // Get task status type
    getTaskStatusType: function getTaskStatusType(status) {
      var typeMap = {
        0: 'warning',
        1: 'success',
        2: 'primary',
        '-1': 'danger'
      };
      return typeMap[status] || 'info';
    },
    // Cancel task
    handleCancelTask: function handleCancelTask(row) {
      var _this14 = this;
      if (row.processStatus !== 0) {
        this.$message.warning('只能取消待执行的任务');
        return;
      }
      this.$confirm("\u786E\u5B9A\u8981\u53D6\u6D88\u4EFB\u52A1 \"".concat(row.taskName, "\" \u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _scheduledShelfTask.cancelScheduledTask)(row.id).then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this14.$message.success('取消成功');
            _this14.handleQueryScheduledTasks();
          }
        }).catch(function (err) {
          _this14.$message.error(err.message || '取消失败');
        });
      }).catch(function () {});
    },
    // Delete task
    handleDeleteTask: function handleDeleteTask(row) {
      var _this15 = this;
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u4EFB\u52A1 \"".concat(row.taskName, "\" \u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _scheduledShelfTask.deleteScheduledTask)(row.id).then(function (res) {
          if (res.code === 0 || res.code === 200) {
            _this15.$message.success('删除成功');
            _this15.handleQueryScheduledTasks();
          }
        }).catch(function (err) {
          _this15.$message.error(err.message || '删除失败');
        });
      }).catch(function () {});
    },
    // Task pagination
    handleTaskSizeChange: function handleTaskSizeChange(size) {
      this.taskPagination.limit = size;
      this.handleQueryScheduledTasks();
    },
    handleTaskCurrentChange: function handleTaskCurrentChange(page) {
      this.taskPagination.page = page;
      this.handleQueryScheduledTasks();
    },
    // View related groups
    handleViewRelatedGroups: function handleViewRelatedGroups(task) {
      if (!task.groupIds || task.groupIds.length === 0) {
        this.$message.warning('暂无关联分组');
        return;
      }
      this.relatedGroupsDialogVisible = true;
      this.relatedGroupsLoading = true;
      this.relatedGroupsList = this.availableGroups.filter(function (group) {
        return task.groupIds.includes(group.id);
      });
      this.relatedGroupsLoading = false;
    },
    // Open import dialog
    handleOpenGroupShelfImportDialog: function handleOpenGroupShelfImportDialog() {
      this.importDialogVisible = true;
    },
    // Download template
    handleDownloadGroupShelfTemplate: function handleDownloadGroupShelfTemplate() {
      var _this16 = this;
      (0, _menuStoreTemplate.downloadGroupShelfTemplate)().then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '分组上下架导入模板.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).catch(function (error) {
        _this16.$message.error('下载失败');
      });
    },
    // Confirm import
    handleConfirmGroupShelfImport: function handleConfirmGroupShelfImport() {
      var files = this.$refs.groupShelfUploadRef.uploadFiles;
      if (!files || files.length === 0) {
        this.$message.warning('请选择要导入的文件');
        return;
      }
      this.groupShelfImporting = true;
      this.$refs.groupShelfUploadRef.submit();
    },
    // Upload success
    handleGroupShelfUploadSuccess: function handleGroupShelfUploadSuccess(response) {
      var _this17 = this;
      this.groupShelfImporting = false;
      if (response.code === 200 || response.code === 0) {
        var data = response.data;
        if (data && data.status === 'created') {
          this.groupShelfTaskId = data.taskId;
          this.groupShelfTaskVisible = true;
          this.$message.success('导入任务已创建，正在后台执行');
          this.startPollingTaskProgress();
          // 3秒后关闭弹窗
          setTimeout(function () {
            _this17.importDialogVisible = false;
          }, 3000);
        } else {
          this.$message.error(response.msg || '导入失败');
        }
      } else {
        this.$message.error(response.msg || '导入失败');
      }
    },
    // Upload error
    handleGroupShelfUploadError: function handleGroupShelfUploadError(err) {
      this.groupShelfImporting = false;
      this.$message.error('上传失败');
    },
    // Close import dialog
    handleImportDialogClose: function handleImportDialogClose() {
      if (this.$refs.groupShelfUploadRef) {
        this.$refs.groupShelfUploadRef.clearFiles();
      }
      if (this.groupShelfTaskTimer) {
        clearInterval(this.groupShelfTaskTimer);
      }
      this.groupShelfTaskVisible = false;
      this.groupShelfTaskId = null;
      this.groupShelfImporting = false;
    },
    // Start polling
    startPollingTaskProgress: function startPollingTaskProgress() {
      var _this18 = this;
      if (this.groupShelfTaskTimer) {
        clearInterval(this.groupShelfTaskTimer);
      }
      this.groupShelfTaskTimer = setInterval(function () {
        _this18.pollTaskProgress();
      }, 2000);
    },
    // Poll progress
    pollTaskProgress: function pollTaskProgress() {
      if (!this.groupShelfTaskId) return;
      // Implement progress polling logic here
    },
    // ========== 门店导入相关方法 ==========
    // Open store import dialog
    handleOpenStoreImportDialog: function handleOpenStoreImportDialog() {
      this.storeImportDialogVisible = true;
      this.storeImportForm.operation = 'check';
    },
    // Download store import template
    handleDownloadStoreTemplate: function handleDownloadStoreTemplate() {
      var _this19 = this;
      if (!this.storeImportForm.operation) {
        this.$message.warning('请先选择操作类型');
        return;
      }
      var operation = this.storeImportForm.operation === 'check' ? '勾选' : '反选';
      (0, _menuStoreTemplate.downloadImportTemplate)(this.storeImportForm.operation).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "\u95E8\u5E97".concat(operation, "\u5BFC\u5165\u6A21\u677F.xlsx");
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).catch(function (error) {
        console.error('下载失败:', error);
        _this19.$message.error('下载失败');
      });
    },
    // Confirm store import
    handleConfirmStoreImport: function handleConfirmStoreImport() {
      if (!this.storeImportForm.operation) {
        this.$message.warning('请选择操作类型');
        return;
      }
      var files = this.$refs.storeUploadRef.uploadFiles;
      if (!files || files.length === 0) {
        this.$message.warning('请选择要导入的文件');
        return;
      }
      this.storeImporting = true;
      this.$refs.storeUploadRef.submit();
    },
    // Store upload success callback
    handleStoreUploadSuccess: function handleStoreUploadSuccess(response, file, fileList) {
      var _this20 = this;
      this.storeImporting = false;
      if (response.code === 200 || response.code === 0) {
        // 处理导入结果
        var data = response.data;
        if (data && data.storeIds) {
          // 根据操作类型处理门店选择
          this.$nextTick(function () {
            if (_this20.storeImportForm.operation === 'check') {
              // 勾选模式：勾选指定的门店
              _this20.$refs.treeRef.setCheckedKeys(data.storeIds);
            } else {
              // 反选模式：取消勾选指定的门店
              var currentKeys = _this20.$refs.treeRef.getCheckedKeys();
              var keysToUncheck = data.storeIds;
              var newKeys = currentKeys.filter(function (key) {
                return !keysToUncheck.includes(key);
              });
              _this20.$refs.treeRef.setCheckedKeys(newKeys);
            }
            // 更新选中门店数量
            _this20.handleCheck();
          });
          this.$message.success("\u5BFC\u5165\u6210\u529F\uFF0C\u5BFC\u5165".concat(data.storeIds.length, "\u4E2A\u95E8\u5E97"));
          // 成功后关闭弹窗
          this.storeImportDialogVisible = false;
        } else if (response.msg) {
          this.$message.warning(response.msg);
        }
      } else {
        this.$message.error(response.msg || '导入失败');
      }
    },
    // Store import dialog close handler
    handleStoreImportDialogClose: function handleStoreImportDialogClose() {
      // 清除上传文件列表
      if (this.$refs.storeUploadRef) {
        this.$refs.storeUploadRef.clearFiles();
      }
      // 重置操作类型
      this.storeImportForm.operation = 'check';
    },
    // Store upload error callback
    handleStoreUploadError: function handleStoreUploadError(err, file, fileList) {
      this.storeImporting = false;
      this.$message.error('上传失败：' + err.message);
    }
  }
};